export default "__VITE_ASSET__C9v9qqUF__"